import { FC, useState } from 'react';
import SimpleModal from 'components/SimpleModal';
import { archiveTeam } from 'ProfileModule/services/archiveTeamApi';

export type SetRetentionPeriodModalProps = {
  teamId: number;
  token?: string;
  headers?: Record<string, string>;
  onClose: VoidFunction;
};

const SetRetentionPeriodModal: FC<SetRetentionPeriodModalProps> = ({
  teamId,
  token,
  headers,
  onClose,
}) => {
  const [days, setDays] = useState<number | undefined>(undefined);
  const isInvalid = days === undefined || !Number.isInteger(days) || days <= 0;

  return (
    <SimpleModal
      open
      onClose={onClose}
      disableConfirmButton={isInvalid}
      onConfirm={async () => {
        if (!token) {
          console.error('Auth token missing. Cannot set retention period.');
          onClose();
          return;
        }
        try {
          await archiveTeam({
            params: {
              teamId,
              customizedDataPreservationPeriod: days,
              reasonToArchive: 'set data retention',
            },
            token,
            config: headers ? { headers } : {},
          });
        } catch (err) {
          console.error('Failed to set data retention period', err);
        }
        onClose();
      }}
      headerText="Set Data Retention Period"
      confirmButtonText="Save"
      Body={
        <div>
          <div>Enter the number of days to retain data after deactivation.</div>
          <input
            style={{ marginTop: 8, width: '100%' }}
            type="number"
            min={1}
            value={days ?? ''}
            onChange={(e) => setDays(e.target.value === '' ? undefined : Number(e.target.value))}
          />
        </div>
      }
    />
  );
};

export default SetRetentionPeriodModal;
